import React, { Component } from 'react';
import styles from './styles.scss';
import { connect } from 'react-redux';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import { userActions } from 'actions/api/users';

class Survey extends Component {
  openForm = () => {
    this.typeformEmbed.typeform.open();
    this.props.dispatch(
      userActions.save({
        data: {
          id: this.props.currentUser.id,
          completed_type_embed_form: true
        },
        background: true
      })
    );
  };

  render() {
    const { currentUser } = this.props;

    return (
      <div className="ExamplePopup">
        <ReactTypeformEmbed
          popup
          autoOpen={false}
          url="https://lodplanner.typeform.com/to/BZuypP"
          hideHeaders
          hideFooter
          buttonText="Go!"
          style={{ display: 'none' }}
          ref={tf => {
            this.typeformEmbed = tf;
          }}
          onSubmit={console.log}
        />
        <div className={styles.link} onClick={this.openForm}>
          {currentUser.completed_type_embed_form
            ? 'Update My Profile'
            : 'Complete My Profile'}
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    userTypes: state.config.user_types,
    currentUser: state.users.map[state.sessionSettings.currentUserId]
  };
})(Survey);



// WEBPACK FOOTER //
// ./src/components/navbar/survey/index.js